import { Beneficiario } from "./Beneficiario";

export class CartaoBeneficiario{
  tokenCupom: string;
  beneficiario: Beneficiario;
  croDentista: string;
  ufDentista: string;
  aceito_SMS_e_Email: boolean;
}
